import { useAppStore } from '@/store/appStore';
import { useMenuStore } from '@/store/menuStore';
import {
  Breadcrumb,
  Button,
  Flex,
  Icons,
  Layout,
  Space,
  theme,
  Typography,
} from '@contiple/antd-ds';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import { useContentHeader } from './MainHeaderButton/useContentHeader';

const { Text } = Typography;
const { MenuUnfoldOutlinedIcon } = Icons;

const MainContent = () => {
  const { menuPathMap } = useMenuStore();
  const location = useLocation();
  const { t } = useTranslation();
  const { lnbExpanded, setLnbExpanded } = useAppStore();
  const { headerActions } = useContentHeader();
  const { Content } = Layout;

  const { token } = theme.useToken();

  const getMenuName = (path: string, menus: string[]) => {
    const currentMenu = menuPathMap.get(path);
    if (currentMenu) {
      menus.push(currentMenu.name || currentMenu.key || '');
    }
    if (currentMenu?.parent) {
      getMenuName(currentMenu.parent, menus);
    }
  };

  const getMenuLabel = useMemo(
    () => () => {
      const menus = [] as string[];
      getMenuName(location.pathname, menus);
      return [...new Set(menus.filter((item) => item !== '').reverse())];
    },
    [location.pathname, menuPathMap, getMenuName]
  );

  const menus = getMenuLabel();

  const breadcrumbItems = menus.map((item) => ({
    title: <Text>{t(item)}</Text>,
  }));

  return (
    <Content style={{ flex: 1 }}>
      {/* Content Header */}
      <Flex
        style={{
          height: '52px',
          padding: '8px 20px',
          borderBottom: `1px solid ${token.custom.menu.colorSplit}`,
        }}
        align="center"
        justify="space-between">
        {menus.length > 1 && (
          <Space align="center" size={16}>
            {!lnbExpanded && (
              <Button
                type="text"
                icon={<MenuUnfoldOutlinedIcon />}
                onClick={() => setLnbExpanded(true)}
              />
            )}
            <Breadcrumb separator=">" items={breadcrumbItems} />
          </Space>
        )}
        <Space align="center" size={16}>
          {headerActions}
        </Space>
      </Flex>

      {/* Content Body */}
      <Content
        style={{
          padding: '20px',
          height: `calc(100vh - ${menus.length > 1 ? 106 : 56}px)`,
          overflowY: 'auto',
        }}>
        <Outlet />
      </Content>
    </Content>
  );
};

export default MainContent;
